import clsx from "clsx";

const Question = ({ children, ...rest }) => {
  return (
    <div
      {...rest}
      className={clsx(
        "max-w-[75%] lg:max-w-[55%] ml-auto w-fit bg-pink-100 py-4 px-6 rounded-xl leading-6 font-notosans  whitespace-pre-wrap",
        rest.className
      )}
    >
      {children}
    </div>
  );
};

export default Question;
